/**
 * @generated SignedSource<<de07aca3648952320d1cdd8bf0e02ada>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SportIcon_sport$data = {
  readonly slug: string;
  readonly " $fragmentType": "SportIcon_sport";
};
export type SportIcon_sport$key = {
  readonly " $data"?: SportIcon_sport$data;
  readonly " $fragmentSpreads": FragmentRefs<"SportIcon_sport">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SportIcon_sport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "Sport",
  "abstractKey": null
};

(node as any).hash = "c36990fc9a578baee2d32a334a6c60d4";

export default node;
